export const normalizeAutoVatSetting = (value) => {
  if (value === true || value === 1 || value === '1') return true;
  if (value === false || value === 0 || value === '0') return false;
  return false;
};

export const getDefaultVatChecked = (value) => normalizeAutoVatSetting(value);

export const shouldDisableVatCheckbox = (value) => normalizeAutoVatSetting(value);
